import { render, staticRenderFns } from "./CloseModal.vue?vue&type=template&id=6f5e8346&scoped=true&"
import script from "./CloseModal.vue?vue&type=script&lang=ts&"
export * from "./CloseModal.vue?vue&type=script&lang=ts&"
import style0 from "./CloseModal.vue?vue&type=style&index=0&id=6f5e8346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e8346",
  null
  
)

export default component.exports